import LogOutLink from "../LogOutLink";
import Layout from "./Layout";

export default function StaffTokenMismatch(): JSX.Element {
  return (
    <Layout title="Invalid Login">
      <p>
        You are trying to log into a staff account with a non-staff login, or
        vice versa. Please log out and log back in with the correct account.
      </p>
      <LogOutLink />
    </Layout>
  );
}
